<template>
  <div class="content-main">

    <div class="shanzha">

      <div class="header flex-box">
        <img class="headimg" :src="$store.state.userinfo.headimg">
        <div class="nickname-and-remain">
          <div class="nickname">{{$store.state.userinfo.nickname}}</div>
          <!-- <div class="remain" v-if="remain > 0">可用留言额度：{{remain}}条</div> -->
        </div>
      </div>

      <div class="functions">
        <div class="function flex-box" @click="goMessageRecords()">
          <div class="icon-and-title flex-box"><van-icon class="function-icon" name="bars" /><span class="function-title">我写的留言</span></div>
          <van-icon name="arrow" />
        </div>
        <div class="function flex-box" @click="getFocusRecords()">
          <div class="icon-and-title flex-box"><van-icon class="function-icon" name="like-o" /><span class="function-title">特别关注</span></div>
          <van-icon name="arrow" />
        </div>
        <!-- <div class="function flex-box" @click="goBought()">
          <div class="icon-and-title flex-box"><van-icon class="function-icon" name="gem" /><span class="function-title">订单记录</span></div>
          <van-icon name="arrow" />
        </div> -->
        <div class="function flex-box" @click="goFeedbackEdit()">
          <div class="icon-and-title flex-box"><van-icon class="function-icon" name="question" /><span class="function-title">问题反馈</span></div>
          <van-icon name="arrow" />
        </div>
      </div>

    </div>

    <van-tabbar v-model="tabActive" active-color="#f1b8af">
      <van-tabbar-item icon="wap-home" @click="goHome()">首页</van-tabbar-item>
      <van-tabbar-item icon="eye-o" @click="goMessageCheck()">看留言</van-tabbar-item>
      <van-tabbar-item icon="envelop-o" @click="goMessageCreate()">写留言</van-tabbar-item>
      <van-tabbar-item icon="manager-o">个人中心</van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { Toast, Popup, Dialog } from 'vant'

export default{
  data(){
    return {
      tabActive: 3,
      remain: 0
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goHome(){
      this.$router.replace("/")
    },
    goMessageCreate(){
      if(this.$store.state.userinfo.silent == 1){
        Toast('系统正在维护中，暂时无法创建留言，仅可查看留言～')
      }else{
        this.$router.replace("/message_create_combo")
      }
    },
    goMessageCheck(){
      this.$router.replace("/message_check")
    },
    goMessageCheckSpecific(receiver){
      this.$router.replace("/message_check?receiver=" + receiver)
    },
    goMessageRecords(){
      this.handleRouter('/message_records')
    },
    goFeedbackEdit(){
      this.handleRouter('/feedback_edit')
    },
    goBought(){
      this.handleRouter('/bought')
    },
    getFocusRecords(){
      this.handleRouter('/special_focus_records')
    },
    wxConfigInit(){
      this.$api.get('/shanzhadao/get_wx_js_config_shanzhadao', {url: window.location.href}, res => {
        if(res.code == 200 && res.config){
          // alert('config: ' +JSON.stringify(res.config))
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.config.app_id, // 必填，公众号的唯一标识
            timestamp: res.config.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.config.noncestr, // 必填，生成签名的随机串
            signature: res.config.signature,// 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
          });

          let share_nickname = this.$store.state.userinfo.nickname
          let share_title = `${share_nickname}给你写了一条留言～`
          let share_desc = '这里有你的故事'
          let share_link = this.$store.state.siteDomain
          let share_img = this.$store.state.userinfo.headimg

          let openid = this.$store.state.userinfo.openid
          let site_code = this.$store.state.siteCode
          let _this = this
          //分享到朋友圈（即将废弃）
          wx.onMenuShareTimeline({
            title: share_title, // 分享标题
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_img, // 分享图标
            success: function () {
              // 用户点击了分享后执行的回调函数
              _this.$hawutil.reportShare(site_code, openid)
            }
          })
          //分享给朋友（即将废弃）
          wx.onMenuShareAppMessage({
            title: share_title, // 分享标题
            desc: share_desc, // 分享描述
            link: share_link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share_img, // 分享图标
            type: '', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户点击了分享后执行的回调函数
              _this.$hawutil.reportShare(site_code, openid)
            }
          })
        }
      })
    },
    checkUserGardenLimit(){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/garden/check_user_garden_limit', {openid: openid}, res => {
        if(res.code == 200){
          this.remain = res.limit
        }
      })
    }
  },
  mounted(){
    this.wxConfigInit()
    // this.checkUserGardenLimit()
  }
}
</script>

<style scoped>
.content-main{ min-height:100vh;background-color: #f6f6f6;color:#f1b8af;}
/* .shanzha{padding:15px;padding-top:25px;padding-bottom:70px;} */
.shanzha .header{background:#f1b8af;height:150px;padding-left:50px;margin-bottom:70px;color:#121212;font-size:18px;}
.shanzha .header .headimg{width:75px;border-radius:75px;margin-right:20px;}
.shanzha .header .nickname-and-remain{text-align:left;}
.shanzha .header .remain{font-size:14px;color:#dfdfdf;margin-top:10px;}
.shanzha .functions{padding:0px 30px;color:#646464;}
.shanzha .function{height:50px;background:#fff;padding:0px 20px;justify-content:space-between;margin-bottom:30px;}
.shanzha .function .icon-and-title{align-items:center;}
.shanzha .function .function-title{margin-left:15px;}
.shanzha .function .function-icon{font-size:20px;}
</style>
